import { memo } from 'react';
import classNames from 'classnames';

import TypographyV2 from '../../../typographyv2/typographyv2';

import { NavItemProps } from '../nav-item.config';
import { NavItemOutboundIcon } from '../nav-item-outbound-icon/nav-item-outbound-icon';

import './nav-item-content.scss';

export interface NavItemContentProps extends Pick<NavItemProps, 'button' | 'linkDescription' | 'flag'> {}

export const NavItemContent = memo(({ button, flag, linkDescription }: NavItemContentProps) => {
  const isOutboundLink = button?.buttonLink?.attributes?.target === '_blank';

  return (
    <div
      className={classNames('snowflake-mega-nav-nav-item-wrapper', {
        'snowflake-mega-nav-nav-item-wrapper-without-description': !linkDescription,
      })}
      data-testid="snowflake-mega-nav-nav-item-content"
    >
      <div className="snowflake-mega-nav-nav-item-title-wrapper">
        <TypographyV2 className="snowflake-mega-nav-nav-item-title" variant="body2">
          {button?.text}
        </TypographyV2>
        {!linkDescription && isOutboundLink ? (
          <NavItemOutboundIcon className="snowflake-mega-nav-nav-item-stick-icon-to-title" />
        ) : null}
        {flag && (
          <TypographyV2
            className="snowflake-mega-nav-nav-item-flag"
            dataTestId="snowflake-mega-nav-nav-item-flag"
            variant="body4"
          >
            {flag}
          </TypographyV2>
        )}
      </div>
      {linkDescription && (
        <TypographyV2
          className={classNames('snowflake-mega-nav-nav-item-description', {
            'snowflake-mega-nav-nav-item-description-new-window': isOutboundLink,
          })}
          dataTestId="snowflake-mega-nav-nav-item-description"
          variant="span"
        >
          {linkDescription}
          {isOutboundLink && <NavItemOutboundIcon />}
        </TypographyV2>
      )}
    </div>
  );
});

NavItemContent.displayName = 'NavItemContent';
